import React, { useState } from "react";
import { Form, Input, Select, Button, Row, Col,DatePicker, notification,message,TimePicker,InputNumber } from "antd";
import { post } from "../../../../api/post";
import { getAccessTokenApi } from "../../../../api/auth";

import "./AddWorkersForm.scss";


export default function AddWorkersForm(props) {
  const { setIsVisibleModal, setReloadWorkers } = props;
  const [workerData, setWorkerData] = useState({co2emissions: 0.0});
  //const { workerData, setWorkerData } = props;
  const { Option } = Select;
  //console.log('entro a add form')
  //console.log(workerData);
  const addWorker = (event) => {
    //console.log('entro a add user form interno')
    event.preventDefault();

    if (
      !workerData.name ||
         !workerData.email ||
         !workerData.bornDate ||
         !workerData.frequencySalary ||
         !workerData.timetable ||
         !workerData.hours ||
         !workerData.frequencyHours ||
         !workerData.contactType ||
         !workerData.initWorkDate 
      // ||!workerData.co2emissions
    ) {
      // notification["error"]({
      //   message: "Todos los campos son obligatorios.",
      // });
      message.error("Todos los campos son obligatorios.")
    } else {
      //const accesToken = getAccessTokenApi();
      // if(!workerData.hourcost )setWorkerData({ ...workerData, co2emissions: 0.0 })
      // createVehicleAPI(workerData)
      post(workerData,'create-worker','create-worker','')
        .then((response) => {
          // notification["success"]({
          //   message: response,
          // });
          message.success('Worker created')
          setIsVisibleModal(false);
          setReloadWorkers(true);
          // setWorkerData({});
        })
        .catch((err) => {
          // notification["error"]({
          //   message: err.message,
          // });
          message.error(err.message)
        });
    }
    //console.log("CREARUSUARIO");
    //console.log(workerData);
  };
  return (
    <Form className="form-add" onSubmit={addWorker}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Name"
              value={workerData.name}
              onChange={(e) =>
                setWorkerData({ ...workerData, name: e.target.value })
              }
            /> 
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Email"
              value={workerData.email}
              onChange={(e) =>
                setWorkerData({ ...workerData, email: e.target.value })
                
              }
            /> 
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Salary'
              name='salary'
              min={0}
              max={999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setWorkerData({ ...workerData, salary: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Payment type"
              onChange={(e) => setWorkerData({ ...workerData, frequencySalary: e })}
              value={workerData.frequencySalary}
              >
              <Option value="annual">Annual</Option>
              <Option value="monthly">Monthly</Option>
              <Option value="hours">Hours</Option>
            </Select>
            </Form.Item>
          </Col> 
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Working hours'
              name='hours'
              min={0}
              max={100}
              step={0.5}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setWorkerData({ ...workerData, hours: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Frequency"
              onChange={(e) => setWorkerData({ ...workerData, frequencyHours: e })}
              value={workerData.frequencyHours}
              >
              <Option value="month">Per month</Option>
              <Option value="week">Per week</Option>
              <Option value="day">Per day</Option>
            </Select>
            </Form.Item>
          </Col> 
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Timetable"
              value={workerData.timetable}
              onChange={(e) =>
                setWorkerData({ ...workerData, timetable: e.target.value })
              }
            /> 
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Contract type"
              onChange={(e) => setWorkerData({ ...workerData, contactType: e })}
              value={workerData.contactType}
              >
              <Option value="indefinite">Indefinite</Option>
              <Option value="temporary">Temporary</Option>
              <Option value="hourly">Hourly</Option>
            </Select>
            </Form.Item>
          </Col> 
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <DatePicker 
            name='Birth Date'
            placeholder="Birth Date"
            // value={hubData.earlyTime}
            // format={'HH:mm'} 
            onChange={(date, dateString)=>{
              // console.log(date, dateString)
              setWorkerData({ ...workerData, bornDate: dateString })
              }}/> 
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
          <DatePicker 
            name='Date of joining the company'
            placeholder="Date of joining the company"
            // value={workerData.lateTime}
            // format={'HH:mm'} 
            onChange={(date, dateString)=>{
              setWorkerData({ ...workerData, initWorkDate:dateString })
              }}/> 
            </Form.Item>
        </Col>
      </Row>
    <Row>
      <Form.Item>
        <Button style={{
      backgroundColor:'white',
      width:'225px',
      borderWidth:'2px',
      fontSize:'15px',
      color:'rgb(35,148,212)',
      fontFamily:'report-bold',
       }} type="submit" htmlType="submit" className="btn-submit" onClick={addWorker}>
          Create worker
        </Button>
      </Form.Item>
    </Row>
      
    </Form>
  );
}
